import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../context/LanguageContext';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const { language, setLanguage, t } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-1 cursor-pointer bg-transparent border-none p-0"
        >
          <span className={`text-2xl font-serif font-bold ${isScrolled ? 'text-[#1A2B4A]' : 'text-white'}`}>
            TS Consulting
          </span>
          <span className="w-2 h-2 rounded-full bg-[#C9A961]"></span>
        </button>

        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-medium transition-colors hover:text-[#C9A961] relative group ${
              isScrolled ? 'text-[#1A2B4A]' : 'text-white'
            }`}
          >
            {t('nav.about')}
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C9A961] transition-all group-hover:w-full"></span>
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className={`text-sm font-medium transition-colors hover:text-[#C9A961] relative group ${
              isScrolled ? 'text-[#1A2B4A]' : 'text-white'
            }`}
          >
            {t('nav.services')}
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C9A961] transition-all group-hover:w-full"></span>
          </button>
          <button
            onClick={() => scrollToSection('regions')}
            className={`text-sm font-medium transition-colors hover:text-[#C9A961] relative group ${
              isScrolled ? 'text-[#1A2B4A]' : 'text-white'
            }`}
          >
            {t('nav.regions')}
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C9A961] transition-all group-hover:w-full"></span>
          </button>
          <button
            onClick={() => scrollToSection('why-us')}
            className={`text-sm font-medium transition-colors hover:text-[#C9A961] relative group ${
              isScrolled ? 'text-[#1A2B4A]' : 'text-white'
            }`}
          >
            {t('nav.whyUs')}
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C9A961] transition-all group-hover:w-full"></span>
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-medium transition-colors hover:text-[#C9A961] relative group ${
              isScrolled ? 'text-[#1A2B4A]' : 'text-white'
            }`}
          >
            {t('nav.contact')}
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C9A961] transition-all group-hover:w-full"></span>
          </button>
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setLanguage(language === 'en' ? 'et' : 'en')}
            className={`px-4 py-2 rounded-full border transition-colors whitespace-nowrap ${
              isScrolled
                ? 'border-[#1A2B4A] text-[#1A2B4A] hover:bg-[#1A2B4A] hover:text-white'
                : 'border-white text-white hover:bg-white hover:text-[#1A2B4A]'
            }`}
          >
            <span className={language === 'en' ? 'font-bold' : ''}>EN</span>
            {' | '}
            <span className={language === 'et' ? 'font-bold' : ''}>ET</span>
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block px-6 py-2 bg-[#C9A961] text-white rounded-lg font-medium hover:bg-[#B89851] transition-colors whitespace-nowrap"
          >
            {t('nav.getStarted')}
          </button>
        </div>
      </div>
    </nav>
  );
}